import { render, staticRenderFns } from "./ModalMessageDetails.vue?vue&type=template&id=9f729456&scoped=true"
import script from "./ModalMessageDetails.vue?vue&type=script&lang=js"
export * from "./ModalMessageDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f729456",
  null
  
)

export default component.exports